"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _vlpTableCarousel = _interopRequireDefault(require("./vlp-table-carousel.css"));
// Function to handle CTA click events
var ctaTrigger = function ctaTrigger(nameplate, ctaLabel, mksSectionName) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'linkclickevent',
      section_name: mksSectionName,
      component: 'Carousel',
      action: 'CTA Click',
      click_text: ctaLabel,
      nameplate: nameplate
    });
  }
};

// Component for CTA buttons
var VlpCtaWrapper = function VlpCtaWrapper(_ref) {
  var ctaList = _ref.ctaList,
    nameplate = _ref.nameplate,
    mksSectionName = _ref.mksSectionName;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _vlpTableCarousel["default"].vlpCtaWrapper
  }, Array.isArray(ctaList) && ctaList.map(function (_ref2, index) {
    var ctaLink = _ref2.ctaLink,
      ctaStyle = _ref2.ctaStyle,
      openNewTab = _ref2.openNewTab,
      ctaLabel = _ref2.ctaLabel;
    return /*#__PURE__*/_react["default"].createElement("a", {
      key: index,
      href: ctaLink,
      onClick: function onClick() {
        ctaTrigger(nameplate, ctaLabel, mksSectionName);
      },
      className: (0, _clsx["default"])(_vlpTableCarousel["default"].link, _vlpTableCarousel["default"][ctaStyle]),
      target: openNewTab ? '_blank' : '_self',
      rel: "noreferrer"
    }, ctaLabel);
  }));
};

// PropTypes validation

// Default props
VlpCtaWrapper.defaultProps = {
  ctaList: []
};
var _default = VlpCtaWrapper;
exports["default"] = _default;